import React from 'react'
import { Form } from 'semantic-ui-react'
import * as constants from 'kynd_constants'
import { validateEmail } from 'helpers'

import {
  EmailContainer,
  EmailInput,
  FieldWrapper,
  Wrapper
} from './styles'

const handleRecipientsChanges = ( indexToChange, value, setExerciseState) => {
  const trimValue = value.trim()
  setExerciseState((prevState) => {
    const recipients = prevState.recipients.map((item, index) => {
      if (indexToChange === index) {
        return { ...item, username: value, error: trimValue ? !validateEmail(`${trimValue}@${prevState.representative.domain}`) : false }
      }

      return item
    })

    return {
      ...prevState,
      recipients,
      formError: false
    }
  })
}

export default ({ item, index, domain, mode, status, setExerciseState }) => (
    <>
      <FieldWrapper>
        <EmailInput inline>
          {
            item.email
              ? <Wrapper>
                  <label>{index + 1}</label>
                  <EmailContainer>{item.email}</EmailContainer>
                </Wrapper>
              : status === constants.STATUS.ACCEPTED || mode === constants.MODE.ADD_MORE
                ? <>
                    <label>{index + 1}</label>
                    <Form.Input
                      name={`alias_${index + 1}`}
                      placeholder="jane.smith"
                      onChange={(e, { value }) => handleRecipientsChanges(index, value, setExerciseState)}
                      value={item.username}
                      error={item.error}
                    />
                    <EmailContainer>@{domain}</EmailContainer>
                  </>
                : null
          }
        </EmailInput>
      </FieldWrapper>
    </>
)
